import React from 'react'

export const Footer = () => {
  return (
    <div className='footer'>
        <h3>Copyright 2023 TRADEMATE</h3>
    </div>
  )
}
